import getPageLocalesData from '@src/global-locales/get-page-locales-data';
const pageLocalesData = getPageLocalesData();
const textInfo = pageLocalesData.main.firstSection;

export default {
  steamBtn: textInfo.steamBtn,
  AppointmentBtn: textInfo.AppointmentBtn,
  downloadBtn: textInfo.downloadBtn,
  XboxBtn: textInfo.XboxBtn,
  steamBtn1: textInfo.steamBtn1,
  XboxBtn1: textInfo.XboxBtn1
};
